module.exports = __webpack_public_path__ + "img/ok.d2ed162b.jpg";